/*
 *
 * Classes constants
 *
 */

export const FLUSH_STATE = 'app/Classes/FLUSH_STATE';

export const LOAD_CLASSES = 'app/Classes/LOAD_CLASSES';
export const LOAD_CLASSES_SUCCESS = 'app/Classes/LOAD_CLASSES_SUCCESS';
export const LOAD_CLASSES_ERROR = 'app/Classes/LOAD_CLASSES_ERROR';

export const UPDATE_CLASS = 'app/Classes/UPDATE_CLASS';
export const UPDATE_CLASS_SUCCESS = 'app/Classes/UPDATE_CLASS_SUCCESS';
export const UPDATE_CLASS_ERROR = 'app/Classes/UPDATE_CLASS_ERROR';
